import {Coordinates, LanguageShortcutId, LanguageShortcutName} from "../Models/Models";
import {Constants} from "../Models/Constants";

const config = require('../config.json');

const imagesBaseUrl: string = process.env.NODE_ENV === 'development' ? config.imagesLocalUrl : config.imagesUrl;

export class Utils {
    public static getOriginalImageFilePath(currentSiteId: number, imageId: number): string {
        return `${imagesBaseUrl}${currentSiteId}/images/${imageId}/original.jpg`
    }

    public static getCropImageFilePath(currentSiteId: number, imageId: number, cropName: string): string {
        return `${imagesBaseUrl}${currentSiteId}/images/${imageId}/crops/${cropName}`
    }

    public static getThumbnailImageFilePath(currentSiteId: number, imageId: number, width: number, height: number): string {
        return `${imagesBaseUrl}${currentSiteId}/images/${imageId}/${width}x${height}.webp`
    }

    /**
     * Crop files encode their source window as "left_up;right_down.webp".
     * Accepts a bare file name or a full path/URL; returns null when the
     * name doesn't carry coordinates (e.g. a fresh original.jpg).
     */
    private static readonly cropNamePattern = /^(?<left>\d+)_(?<up>\d+);(?<right>\d+)_(?<down>\d+)\.webp$/;

    public static parseCropName(filePathOrName?: string | null): Coordinates | null {
        if (!filePathOrName) return null;

        const fileName = filePathOrName.split('/').pop()?.trim() ?? '';
        const match = fileName.match(Utils.cropNamePattern);
        if (!match?.groups) return null;

        const left = Number(match.groups.left);
        const up = Number(match.groups.up);
        const right = Number(match.groups.right);
        const down = Number(match.groups.down);

        const isValidCrop = right > left && down > up;
        if (!isValidCrop) return null;

        return { filled: true, left, up, right, down };
    }

    public static isUserLoggedIn(currentUserId: number): boolean {
         return currentUserId !== Constants.defaultUserContext.id;
    }

    public static hasUserPickedWebsite(currentWebsiteId: number): boolean {
        return currentWebsiteId !== Constants.defaultSiteContext.id;
    }

    public static getLanguageShortcut(key: number): LanguageShortcutName | string {
        const languageKey = Object.keys(LanguageShortcutId).find(
            (enumKey) => LanguageShortcutId[enumKey as keyof typeof LanguageShortcutId] === key
        );
        return languageKey ? LanguageShortcutId[languageKey] : LanguageShortcutName;
    }

    public static getLanguageShortcutId(short: LanguageShortcutName): LanguageShortcutId {
        const entry = (Object.entries(LanguageShortcutName) as [keyof typeof LanguageShortcutName, string][])
            .find(([, str]) => str === short)!;
        return LanguageShortcutId[entry[0]];
    }

    public static capitalizeFirstLetter(value: string): string {
        if (value == null || typeof value !== "string") {
            return value;
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    public static truncateString(input: string, maxLength: number): string {
        if (input.length <= maxLength)
            return input;
        return input.substring(0, maxLength) + "...";
    }

    public static formatDate(date: string | Date): string {
        return new Date(date).toLocaleDateString('sk-SK', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    }

    public static setDocumentTitle = (title: string) => {
        const tabName : string = localStorage.getItem("tabName");

        if (tabName === undefined || tabName === null || tabName === "") {
            document.title = "Stabilimentum | " + title;
            return;
        }

        document.title = "Stabilimentum | " + tabName + " | " + title;
    };
}
